// Arabisch (ar), timer: zelfde vorm als kioskTimer.nl.ts. Eenvoudig Standaardarabisch; cijfers
// Latijns (de cijferkeuze doet de rest).
export const kioskTimerAr = {
    open: 'المؤقت',
    openRunning: 'المؤقت: بقي {time}',
    title: 'المؤقت',
    minutes: '{n} د',
    custom: 'اختر بنفسك',
    less: 'دقيقة أقل',
    more: 'دقيقة أكثر',
    minutesUnit: 'دقائق',
    forWhat: 'لماذا؟',
    labels: {
        teeth: 'تنظيف الأسنان',
        homework: 'الواجب المدرسي',
        screen: 'وقت الشاشة',
        cooking: 'الطبخ',
    },
    start: 'ابدأ',
    left: 'بقي {time}',
    paused: 'متوقف مؤقتًا',
    pause: 'إيقاف مؤقت',
    resume: 'تابع',
    plusOne: '+1 د',
    stop: 'إيقاف',
    done: 'انتهى الوقت!',
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'انتهى الوقت',
};
//# sourceMappingURL=kioskTimer.ar.js.map